import { Icon } from "./Icon";

export function ResourceError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div className="resource-notice resource-notice--error" role="alert">
      <Icon name="alert" size={20} />
      <div><b>数据暂时没有加载出来</b><span>{message}</span></div>
      <button className="button button--quiet button--small" onClick={onRetry}>重试</button>
    </div>
  );
}

export function LoadingRows({ count = 3 }: { count?: number }) {
  return (
    <div className="loading-rows" role="status" aria-label="正在加载">
      {Array.from({ length: count }, (_, index) => <span key={index} style={{ width: `${88 - index * 7}%` }} />)}
    </div>
  );
}
